<template>
  <v-card class="filter-panel">
    <h1 class="filter-title">Filtrar Entradas</h1>
    <v-form ref="form" @submit.prevent="applyFilters" @keydown.enter.prevent="applyFilters">
      <v-row dense>
        <v-col cols="12" md="4">
          <v-autocomplete label="Origen" v-model="filter.originId" item-value="id" item-title="name" :items="locations"/>
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field label="Cosecha" mask="##-##" v-model="filter.harvesting"/>
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete label="Titular de C.P." v-model="filter.ownerId" item-value="id" item-title="name" :items="companies"/>
        </v-col>
        <v-col cols="12" md="2">
          <v-autocomplete label="Variedad" v-model="filter.grainTypeId" item-value="id" item-title="name" :items="grainTypes"/>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field mask="############" label="C.P. Nro." v-model="filter.numCP"/>
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field type="number" step="10" label="Gramaje Min." v-model="filter.gmgMin"/>
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field type="number" step="10" label="Gramaje Max." v-model="filter.gmgMax"/>
        </v-col>
      </v-row>
      <div class="filter-actions">
        <v-btn type="button" @click="clearFilters" color="secondary" variant="tonal">{{ CONST.CLEAN_FILTERS }}</v-btn>
        <v-btn type="submit" color="primary">{{ CONST.APPLY_FILTERS }}</v-btn>
      </div>
    </v-form>
  </v-card>
</template>
<script>
import CONST from '../../services/common/Constants.js'
import { LOCATION_TYPES, locationsForType } from '@/services/location/LocationTypeUtils'

export default {
  name: 'FilterIncomeForm',

  data: () => ({
    filter: {
      originId: null,
      ownerId: null,
      numCP: null,
      harvesting: null,
      grainTypeId: null,
      gmgMin: null,
      gmgMax: null
    },
    locations: [],
    companies: [],
    grainTypes: []
  }),

  created () {
    this.CONST = CONST
    this.initialize()
  },

  methods: {
    async initialize () {
      await this.$store.dispatch('locationModule/getBaseLocations')
      this.locations = locationsForType(this.$store.getters['locationModule/getBaseLocations'], LOCATION_TYPES.ORIGIN)
      await this.$store.dispatch('companyModule/getBaseCompanies')
      this.companies = this.$store.getters['companyModule/getBaseCompanies']
      await this.$store.dispatch('typesModule/getGrainTypes')
      this.grainTypes = this.$store.getters['typesModule/getGrainTypes']
    },

    applyFilters () {
      this.$store.dispatch('incomeModule/filterItems', Object.assign({}, this.filter))
    },

    clearFilters () {
      this.$refs.form.reset()
      this.$store.dispatch('incomeModule/refreshFilteredIncomes')
    }
  }
}
</script>
